<div class="card-slide" (click)="navigate()">
    <div *ngIf="header" class="card-header">{{header}}</div>
    <div *ngIf="subheader" class="card-subheader">{{subheader}}</div>
    <div *ngIf="text"  class="card-text">{{text}}</div>
    <div class="card-image">
        <img [src]="image"   *ngIf="isImage">
    </div>

</div>